import { imprimirTroco } from 'modulo-gerencial-erp-pacotes-impressora-termica';

import { imprimirServicoNovo, buscarDadosImpressao } from '../utils';

async function imprimir(id, query = '', usar_nova_impressao = false) {
  /* if (!usar_nova_impressao) {
    return await imprimirServicoAntigo(id, 12, query);
  }

  const dados = await buscarDadosImpressao(id, 12);

  const { comandos } = layout(adapter(dados));

  const response = await imprimirServicoNovo(id, 'troco', comandos);
  return response.data; */

  return await imprimirTroco({
    id,
    buscarDadosImpressao,
    chamarServicoImpressoraTermica: imprimirServicoNovo,
    query,
  });
}

export default imprimir;
